module.exports = __webpack_public_path__ + "static/media/1.433a12b6.png";